import { useParams } from "react-router-dom";
import AppLoading from "components/AppLoading/AppLoading";
import { useQueryClient } from "@tanstack/react-query";
import { PageTool404 } from "./PageTool404";
import { Helmet } from "react-helmet-async";
import { PageToolProject } from "./PageToolProject";
import { PageToolViewOnly } from "./PageToolViewOnly";
import { isNonNullish } from "utils/isNonNullish";
import { useGetToolQuery } from "./PageToolQuery";
import { ToolDataProvider } from "./ToolDataProvider";
import { queryKeys } from "django/queryKeys";
import { useCallback } from "react";

export const PageTool = () => {
  const _toolId = useParams<{ toolId: string }>().toolId;
  const toolId = Number(_toolId);

  const { data, isLoading, error } = useGetToolQuery(toolId);

  // Pass a function to children to allow them to invalidate the tool query
  const queryClient = useQueryClient();
  const invalidateToolQuery = useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.tool(toolId),
        exact: true,
      }),
    [queryClient, toolId],
  );
  if (isLoading && data === undefined) {
    return <AppLoading />;
  }

  if (error) {
    return <PageTool404 />;
  }

  return (
    <ToolDataProvider tool={data} invalidateToolQuery={invalidateToolQuery}>
      <Helmet>
        <title>{`${data.name}`}</title>
      </Helmet>
      {
        // if we don't see a project, assume this is view-only
        isNonNullish(data.project) ? <PageToolProject /> : <PageToolViewOnly />
      }
    </ToolDataProvider>
  );
};
